(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amazon-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const component = document.querySelector('[data-amazon-dialog-component]');
    if (!component) return;
    const image = component.querySelector('[data-amazon-dialog-image]');
    const closeBtn = component.querySelector('[data-amazon-dialog-close]');
    const triggers = document.querySelectorAll('[data-amazon-trigger]');
    if (!image || !closeBtn || triggers.length === 0) return;

    let lastTrigger = null;

    const open = (trigger) => {
      const src = trigger.dataset.fullSrc;
      if (!src) return;
      image.src = src;
      image.alt = trigger.dataset.alt || '';
      lastTrigger = trigger;
      if (typeof component.showDialog === 'function') {
        component.showDialog();
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        open(trigger);
      });
    });

    closeBtn.addEventListener('click', () => {
      if (typeof component.closeDialog === 'function') {
        component.closeDialog();
      }
    });

    component.addEventListener('dialog:close', () => {
      image.removeAttribute('src');
      if (lastTrigger) {
        lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peh-gallery')) {
    customElements.define('peh-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-peh-slider]');
        this.slides = Array.from(this.querySelectorAll('[data-peh-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-peh-thumb]'));
        if (!this.slider || !this.slides.length) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.scrollToMedia(thumb.dataset.mediaId));
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                  this.setActive(entry.target.dataset.mediaId);
                }
              });
            },
            { root: this.slider, threshold: [0.6] }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      scrollToMedia(mediaId) {
        const slide = this.slides.find((s) => s.dataset.mediaId === mediaId);
        if (!slide) return;
        this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      setActive(mediaId) {
        if (!this.thumbs.length) return;
        this.thumbs.forEach((t) => {
          t.classList.toggle('peh__thumb--active', t.dataset.mediaId === mediaId);
        });
      }
    });
  }

  (function () {
    const buttons = document.querySelectorAll('.peh__atc--primary[data-sticky-atc-anchor]');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      const original = btn.textContent;
      const addingLabel = btn.dataset.addingLabel || 'Adding…';
      const addedLabel = btn.dataset.addedLabel || '✓ Added!';
      let revertTimer = null;
      let safetyTimer = null;

      function clearTimers() {
        if (revertTimer) {
          clearTimeout(revertTimer);
          revertTimer = null;
        }
        if (safetyTimer) {
          clearTimeout(safetyTimer);
          safetyTimer = null;
        }
      }

      function reset() {
        clearTimers();
        btn.classList.remove('peh__atc--loading', 'peh__atc--success');
        btn.removeAttribute('aria-busy');
        btn.textContent = original;
      }

      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        clearTimers();
        btn.classList.remove('peh__atc--success');
        btn.classList.add('peh__atc--loading');
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = addingLabel;
        safetyTimer = setTimeout(reset, 6000);
      });

      document.addEventListener('cart:update', (event) => {
        const data = event.detail && event.detail.data;
        if (data && data.didError) return;
        if (data && data.productId != null && btn.dataset.productId && String(data.productId) !== btn.dataset.productId) return;
        clearTimers();
        btn.classList.remove('peh__atc--loading');
        btn.classList.add('peh__atc--success');
        btn.removeAttribute('aria-busy');
        btn.textContent = addedLabel;
        revertTimer = setTimeout(reset, 1500);
      });

      document.addEventListener('cart:error', reset);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-vapor-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;

    function reveal(node) {
      if (node.dataset.vaporObserved === '1') return;
      node.dataset.vaporObserved = '1';
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -10% 0px' });
      observer.observe(node);
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-vapor-reveal]').forEach(reveal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-screenshots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const component = document.querySelector('[data-review-dialog-component]');
    if (!component) return;
    const image = component.querySelector('[data-review-dialog-image]');
    const closeBtn = component.querySelector('[data-review-dialog-close]');
    const triggers = document.querySelectorAll('[data-review-trigger]');
    if (!image || !closeBtn || triggers.length === 0) return;

    let lastTrigger = null;

    const open = (trigger) => {
      const src = trigger.dataset.fullSrc;
      if (!src) return;
      image.src = src;
      image.alt = trigger.dataset.alt || '';
      lastTrigger = trigger;
      if (typeof component.showDialog === 'function') {
        component.showDialog();
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        open(trigger);
      });
    });

    closeBtn.addEventListener('click', () => {
      if (typeof component.closeDialog === 'function') {
        component.closeDialog();
      }
    });

    component.addEventListener('dialog:close', () => {
      image.removeAttribute('src');
      if (lastTrigger) {
        lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-shop-lineup]');
    sections.forEach((root) => {
      if (root.dataset.shopLineupReady === 'true') return;
      root.dataset.shopLineupReady = 'true';

      const filterButtons = root.querySelectorAll('.shop-lineup__filter');
      const sortButtons = root.querySelectorAll('[data-sort-value]');
      const sortLabel = root.querySelector('[data-sort-label]');
      const sortDetails = root.querySelector('.shop-lineup__sort');
      const emptyState = root.querySelector('[data-shop-empty]');
      const grid = root.querySelector('[data-shop-grid]');
      const initialCards = grid ? Array.from(grid.querySelectorAll('[data-product-card]')) : [];
      initialCards.forEach((card, index) => {
        card.dataset.popularIndex = String(index);
      });

      let activeFilter = 'all';
      let activeSort = 'popular';

      const markActiveSort = (value) => {
        sortButtons.forEach((btn) => {
          btn.classList.toggle('is-active', btn.dataset.sortValue === value);
        });
      };

      const applyFilter = (value) => {
        activeFilter = value;
        filterButtons.forEach((btn) => {
          btn.classList.toggle('is-active', btn.dataset.filterValue === value);
        });
        root.classList.toggle('is-filtered', value !== 'all');

        let visible = 0;
        root.querySelectorAll('[data-product-card]').forEach((card) => {
          const tags = (card.dataset.filters || '').split(',').map((t) => t.trim()).filter(Boolean);
          const match = value === 'all' || tags.includes(value);
          card.hidden = !match;
          if (match) visible += 1;
        });

        if (emptyState) emptyState.hidden = visible > 0;
      };

      const applySort = (value) => {
        activeSort = value;
        if (!grid) {
          markActiveSort(value);
          return;
        }
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        cards.sort((a, b) => {
          const pubA = Number(a.dataset.publishedAt || 0);
          const pubB = Number(b.dataset.publishedAt || 0);
          const priceA = Number(a.dataset.price || 0);
          const priceB = Number(b.dataset.price || 0);
          const popA = Number(a.dataset.popularIndex || 0);
          const popB = Number(b.dataset.popularIndex || 0);
          switch (value) {
            case 'newest': return pubB - pubA;
            case 'oldest': return pubA - pubB;
            case 'price-asc': return priceA - priceB;
            case 'price-desc': return priceB - priceA;
            case 'popular':
            default: return popA - popB;
          }
        });
        cards.forEach((card) => grid.appendChild(card));
        if (emptyState) grid.appendChild(emptyState);
        markActiveSort(value);
      };

      filterButtons.forEach((btn) => {
        btn.addEventListener('click', () => applyFilter(btn.dataset.filterValue));
      });

      sortButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          applySort(btn.dataset.sortValue);
          if (sortLabel && btn.dataset.sortText) sortLabel.textContent = btn.dataset.sortText;
          if (sortDetails) sortDetails.open = false;
        });
      });

      document.addEventListener('click', (event) => {
        if (!sortDetails || !sortDetails.open) return;
        if (!sortDetails.contains(event.target)) sortDetails.open = false;
      });

      applySort(activeSort);
      markActiveSort(activeSort);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAtcBar extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      const anchorSelector = this.dataset.anchor || '[data-sticky-atc-anchor]';
      const anchor = document.querySelector(anchorSelector);

      if (!anchor || typeof IntersectionObserver === 'undefined') {
        return;
      }

      this._anchor = anchor;
      this.removeAttribute('hidden');

      this._observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            this.removeAttribute('data-visible');
          } else {
            this.setAttribute('data-visible', 'true');
          }
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
      this._observer.observe(anchor);

      const trigger = this.querySelector('[data-sticky-atc-trigger]');
      if (trigger) {
        this._trigger = trigger;
        this._triggerLabel = trigger.textContent;
        this._addingLabel = trigger.dataset.addingLabel || 'Adding…';
        this._addedLabel = trigger.dataset.addedLabel || '✓ Added!';
        this._revertTimer = null;
        this._safetyTimer = null;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (trigger.disabled) return;
          this._setLoading();
          this._submitHeroForm();
        });

        this._abort = new AbortController();
        const signal = this._abort.signal;
        document.addEventListener('cart:update', (event) => this._onCartUpdate(event), { signal });
        document.addEventListener('cart:error', () => this._reset(), { signal });
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._abort) {
        this._abort.abort();
        this._abort = null;
      }
      this._clearTimers();
    }

    _clearTimers() {
      if (this._revertTimer) {
        clearTimeout(this._revertTimer);
        this._revertTimer = null;
      }
      if (this._safetyTimer) {
        clearTimeout(this._safetyTimer);
        this._safetyTimer = null;
      }
    }

    _setLoading() {
      if (!this._trigger) return;
      this._clearTimers();
      this._trigger.classList.remove('sticky-atc-bar__button--success');
      this._trigger.classList.add('sticky-atc-bar__button--loading');
      this._trigger.setAttribute('aria-busy', 'true');
      this._trigger.textContent = this._addingLabel;
      this._safetyTimer = setTimeout(() => this._reset(), 6000);
    }

    _onCartUpdate(event) {
      if (!this._trigger) return;
      if (event.detail && event.detail.data && event.detail.data.didError) return;
      this._clearTimers();
      this._trigger.classList.remove('sticky-atc-bar__button--loading');
      this._trigger.classList.add('sticky-atc-bar__button--success');
      this._trigger.removeAttribute('aria-busy');
      this._trigger.textContent = this._addedLabel;
      this._revertTimer = setTimeout(() => this._reset(), 1500);
    }

    _reset() {
      if (!this._trigger) return;
      this._clearTimers();
      this._trigger.classList.remove('sticky-atc-bar__button--loading', 'sticky-atc-bar__button--success');
      this._trigger.removeAttribute('aria-busy');
      this._trigger.textContent = this._triggerLabel;
    }

    _submitHeroForm() {
      if (!this._anchor) return;
      const form = this._anchor.closest('form');
      if (form && typeof form.requestSubmit === 'function') {
        try {
          form.requestSubmit(this._anchor);
          return;
        } catch (e) {
          // Fall through to click fallback
        }
      }
      this._anchor.click();
    }
  }

  if (!customElements.get('sticky-atc-bar')) {
    customElements.define('sticky-atc-bar', StickyAtcBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-prelander-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-sticky-prelander-cta]');
    if (!bar) return;

    const triggerPct = parseFloat(bar.dataset.triggerPct || '40');
    let revealed = false;
    let ticking = false;

    const reveal = () => {
      if (revealed) return;
      bar.removeAttribute('hidden');
      revealed = true;
      window.removeEventListener('scroll', onScroll);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const doc = document.documentElement;
        const scrolled = window.scrollY + window.innerHeight;
        const target = doc.scrollHeight * (triggerPct / 100);
        if (scrolled >= target) reveal();
        ticking = false;
      });
    };

    if (triggerPct <= 0) {
      reveal();
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    const forwardUtms = () => {
      const search = window.location.search;
      if (!search || search.length < 2) return;
      const incoming = new URLSearchParams(search);
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
      const carry = utmKeys.filter((k) => incoming.has(k));
      if (carry.length === 0) return;

      const links = document.querySelectorAll('a[href*="/products/"]');
      links.forEach((a) => {
        let url;
        try {
          url = new URL(a.getAttribute('href'), window.location.origin);
        } catch (e) {
          return;
        }
        if (url.origin !== window.location.origin) return;
        carry.forEach((k) => {
          if (!url.searchParams.has(k)) {
            url.searchParams.set(k, incoming.get(k));
          }
        });
        a.setAttribute('href', url.pathname + url.search + url.hash);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', forwardUtms, { once: true });
    } else {
      forwardUtms();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
